import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const ProductContainer = styled.div<any>`
  padding: 15px 0;
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};
  display: flex;
  ${props => props.isChild && `
    padding-left: 116px;
  `}

  .product {
    &-image {
      display: flex;
      border: 1px solid ${props => props.theme.palette.general.greyDark};
      margin: auto 15px auto 0;
      width: 100px;
      height: 110px;
      background: no-repeat 50% 50% / contain;

      > a {
        display: block;
        text-decoration: none;
        margin: auto;

        > div {
          width: 100px;
          height: 110px;
          background: no-repeat 50% 50% / contain;
        }
      }
    }

    &-data {
      > h2 {
        font: ${font('default', 'normal', '18px/1')};
        margin-bottom: 5px;
        ${props => props.isMiniCart && `
          font-size: 16px;
        `}
      }
    }
  }

  .starting-note {
    span {
      margin-right: 5px;
    }
  }
`
